import { apiClient } from './client';
import type { AuthUser, TokenResponse } from '@/types';

export async function login(email: string, password: string): Promise<TokenResponse> {
  // FastAPI expects OAuth2 form fields, not JSON
  const form = new FormData();
  form.append('username', email);
  form.append('password', password);
  return apiClient.postForm<TokenResponse>('/api/auth/login', form);
}

export async function fetchMe(): Promise<AuthUser> {
  return apiClient.get<AuthUser>('/api/auth/me');
}
